import * as React from 'react';
import classnames from 'classnames';
import styles from './sidebarCard.module.css';
export const SidebarCard = ({ dataTestId, classes, children }) => (React.createElement("div", { className: classnames(styles.SidebarCard, classes), "data-test-id": dataTestId }, children));
